import React from "react"
import { useTranslation } from "react-i18next"
import { formatVars } from "../../helpers/translation"
import { formatTimeLeft } from "../../helpers/timeleftfilter.coffee"

const TimeLeftDisplay = ({ className, seconds }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation("generic")

  const formatter = (msgSrc, values) => formatVars(language, msgSrc, values)

  return (
    <div className={className}>{formatTimeLeft(t, formatter)(seconds)}</div>
  )
}

export default TimeLeftDisplay
